import type { SnpApiContact, SnpSubscribeRequest, SnpSubscribeResponse } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class SnpApiLegacy extends Rest implements SnpApiContact {
  readonly name = "SnpApi";
  constructor(
    baseUrl = "/",
    private tenantToken: string
  ) {
    super(baseUrl);
    super.setCommonHeader("X-DES-AK-TENANT-TOKEN", tenantToken);
  }

  async subscribe(subscriptionData: SnpSubscribeRequest, preferredLanguage?: string) {
    const {
      email,
      consent_purposes,
      data_processing_agreement,
      preferredLanguage: preferredLanguageFromForm,
    } = subscriptionData;
    return this.request<SnpSubscribeResponse>(
      "/subscribe",
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          email: email,
          topics: ["marketing"],
          consents: consent_purposes,
          data_processing_agreement,
          preferredLanguage: preferredLanguage ?? preferredLanguageFromForm,
        }),
      },
      true
    );
  }

  async unsubscribe(subscriptionUuid: string, topics: string[], consent_id?: string[]) {
    const response = await this.request<SnpSubscribeResponse>("/unsubscribe", {
      method: "POST",
      body: JSON.stringify({ topics, uuid: subscriptionUuid, consent_id }),
    });
    return response;
  }
}
